import { fontType, main } from '../assets/extras'
import './styles/confirm.css'

const Confirm = ({confirm, setConfirm, onHandle}) => {

    return (
        <div className='mainConfirm' style={{
            animation: confirm.show === true ? "showOn 0.5s linear forwards" : 
            "showOff 0.5s linear forwards",
            display: confirm.show === false ? "none" : "flex",
            zIndex: 100000000
        }}>
            <div className='confirmCont'>
                <div className='texts'>
                    <p style={{
                        fontFamily: fontType.title,
                        fontSize: "30px",
                        flex: 1
                    }}>{confirm.title}</p>
                    <p style={{
                        textAlign: "center",
                        flex: 3,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontFamily: fontType.text,
                        fontSize: "16px"
                    }}>{confirm.text}</p>
                </div>
                <div className='buttons'>
                    <button style={{
                        backgroundColor: "white",
                        marginRight: 10,
                        fontFamily: fontType.title
                    }}
                        onClick={() => {
                            setConfirm(prev => ({
                                ...prev,
                                show: false
                            }))
                        }}
                    >CANCELAR</button>
                    <button style={{
                        backgroundColor: main,
                        fontFamily: fontType.title,
                        color: "white"
                    }}
                        onClick={onHandle}
                    >ACEPTAR</button>
                </div>
            </div>
        </div>
    )
}

export default Confirm